import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-abyss text-white">
        <Loader2 className="h-8 w-8 animate-spin text-aqua" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  // Supplier accounts belong in the supplier portal — redirect BEFORE the customer
  // portal mounts, so no customer-only API calls (which 403 for supplier tokens) fire.
  if (user.role === "supplier_admin") return <Navigate to="/supplier" replace />;
  return children;
}
